import React from 'react';
import { format } from 'date-fns';

import '../../styles/components/admin/AdminPaymentDetailsModal.css';

const PaymentDetailsModal = ({ 
  isOpen, 
  onClose, 
  billing, 
  patient,
  onMarkAsPaid 
}) => {
  if (!isOpen || !billing) return null;

  return (
    <div className="admin-modal-overlay">
      <div className="admin-modal">
        <div className="admin-modal-header">
          <h3>Payment Details</h3>
          <button 
            className="admin-modal-close"
            onClick={onClose}
          >
            ×
          </button>
        </div>
        <div className="admin-modal-body">
          <div className="admin-appointment-details">
            <div className="admin-detail-row">
              <span className="admin-detail-label">Patient:</span>
              <span className="admin-detail-value">
                {patient.firstName} {patient.lastName}
              </span>
            </div>
            <div className="admin-detail-row">
              <span className="admin-detail-label">Doctor:</span>
              <span className="admin-detail-value">
                Dr. {billing.doctor?.firstName} {billing.doctor?.lastName}
              </span>
            </div>
            <div className="admin-detail-row">
              <span className="admin-detail-label">Appointment Date:</span>
              <span className="admin-detail-value">
                {format(new Date(billing.appointmentDate), 'MMMM dd, yyyy')}
              </span>
            </div>
            <div className="admin-detail-row">
              <span className="admin-detail-label">Appointment Time:</span>
              <span className="admin-detail-value">
                {format(new Date(billing.appointmentDate), 'hh:mm a')}
              </span>
            </div>
            <div className="admin-detail-row">
              <span className="admin-detail-label">Session Fee:</span>
              <span className="admin-detail-value">
                ₱{billing.amount || '0.00'}
              </span>
            </div>
            <div className="admin-detail-row">
              <span className="admin-detail-label">Payment Status:</span>
              <span className={`admin-status-indicator admin-billing-${billing.status}`}>
                {billing.status.charAt(0).toUpperCase() + billing.status.slice(1)}
              </span>
            </div>
            <div className="admin-detail-row">
              <span className="admin-detail-label">Payment Method:</span>
              <span className="admin-detail-value">
                {billing.paymentMethod || 'Not specified'}
              </span>
            </div>
            {billing.transactionId && (
              <div className="admin-detail-row">
                <span className="admin-detail-label">Transaction ID:</span>
                <span className="admin-detail-value">
                  {billing.transactionId}
                </span>
              </div>
            )}
            {billing.paymentDate && (
              <div className="admin-detail-row">
                <span className="admin-detail-label">Payment Date:</span>
                <span className="admin-detail-value">
                  {format(new Date(billing.paymentDate), 'MMMM dd, yyyy')}
                </span>
              </div>
            )}
            {billing.notes && (
              <div className="admin-detail-row">
                <span className="admin-detail-label">Notes:</span>
                <span className="admin-detail-value">
                  {billing.notes}
                </span>
              </div>
            )}
            {billing.proofImage && (
              <div className="admin-detail-row admin-payment-proof">
                <span className="admin-detail-label">Payment Proof:</span>
                <img 
                  src={billing.proofImage} 
                  alt="Payment Proof" 
                  className="admin-payment-proof-image"
                  onClick={() => window.open(billing.proofImage, '_blank')}
                />
              </div>
            )}
          </div>
        </div>
        <div className="admin-modal-footer">
          <button 
            className="admin-secondary-button"
            onClick={onClose}
          >
            Close
          </button>
          {billing.status === 'pending' && (
            <button 
              className="admin-primary-button"
              onClick={() => onMarkAsPaid && onMarkAsPaid(billing._id)}
            >
              Mark as Paid
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentDetailsModal;